<template>
	<div v-if="modelValue" class="fixed inset-0 z-50 flex items-center justify-center">
		<!-- Backdrop overlay -->
		<div class="absolute inset-0 bg-black/50" @click="$emit('update:modelValue', false)"></div>

		<!-- Modal content -->
		<div class="relative w-full max-w-sm md:max-w-md p-6 mx-2 md:mx-auto bg-white rounded-lg shadow-xl">
			<div class="flex justify-between items-center mb-4">
				<h3 class="text-lg font-semibold text-ihh-midnight-gray">Confirm Shipping Address</h3>
				<button @click="$emit('update:modelValue', false)" class="text-ihh-slate-gray hover:text-ihh-midnight-gray" aria-label="Close">
					<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
					</svg>
				</button>
			</div>

			<div class="my-2">
				<!-- <p class="mb-3 text-ihh-slate-gray text-sm">Please verify your shipping address is correct before proceeding:</p> -->

				<!-- <div v-if="shippingAddress" class="bg-gray-50 p-4 rounded-md text-ihh-slate-gray">
					<div class="font-medium">{{ shippingAddress.firstName }} {{ shippingAddress.lastName }}</div>
					<div>{{ shippingAddress.address1 }}</div>
					<div v-if="shippingAddress.address2">{{ shippingAddress.address2 }}</div>
					<div>
						{{ shippingAddress.city }}, {{ shippingAddress.stateOrProvince }} {{ shippingAddress.postalCode }}
						<span v-if="shippingAddress?.countryCode">/ {{ shippingAddress?.countryCode }}</span>
					</div>
					<div v-if="shippingAddress.phone" class="mt-2">Phone: {{ formattedPhone }}</div>
				</div> -->
				<div v-if="shippingAddress" class="bg-gray-50 p-4 rounded-md text-ihh-midnight-gray border border-gray-200 shadow-sm">
					<div class="font-semibold">{{ shippingAddress.firstName }} {{ shippingAddress.lastName }}</div>
					<div>{{ shippingAddress.address1 }}</div>
					<div v-if="shippingAddress.address2">{{ shippingAddress.address2 }}</div>
					<div>
						{{ shippingAddress.city }}, {{ shippingAddress.stateOrProvince }} {{ shippingAddress.postalCode }}
						<span v-if="shippingAddress?.countryCode">/ {{ shippingAddress?.countryCode }}</span>
					</div>
					<div v-if="shippingAddress.phone" class="mt-2">Phone: {{ formattedPhone }}</div>
				</div>
				<div v-else class="text-ihh-salmon text-center p-4">No shipping address found</div>
			</div>

			<div class="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-3 mt-4">
				<button @click="editAddress" class="w-full md:w-40 py-2 border border-ihh-slate-gray text-ihh-midnight-gray font-medium rounded hover:bg-gray-100 transition">
					Edit Address
				</button>
				<button @click="confirmAddress" class="w-full md:w-40 py-2 bg-ihh-dark-salmon text-ihh-midnight-gray font-medium rounded hover:bg-ihh-salmon transition">
					Confirm Address
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { useCheckoutStore } from '../../stores/store.js'

export default {
	name: 'ShippingAddressConfirmation',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['update:modelValue', 'address-confirmed', 'edit-address'],
	setup() {
		const checkout = useCheckoutStore()
		return { checkout }
	},
	computed: {
		shippingAddress() {
			return this.checkout?.shipping?.shippingAddress || null
		},
		formattedPhone() {
			const phone = this.shippingAddress?.phone || ''
			const digits = phone.replace(/\D/g, '') // Remove non-numeric characters
			return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') // Format as 512-555-5555
		},
	},
	methods: {
		confirmAddress() {
			this.$emit('address-confirmed')
			this.$emit('update:modelValue', false)
		},
		editAddress() {
			this.$emit('update:modelValue', false)
			this.$emit('edit-address')
		},
	},
}
</script>
